module.exports = __webpack_public_path__ + "media/reskin-images/icon--tool-68db616e.svg";